import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import { classes } from "../utils/classes";
import Heading from "../Heading";
import Paragraph from "../Paragraph";
import Link from "../Link";
import { sxProps, sxPropTypes } from "../props/sx";
import { spacingProps, spacingPropTypes } from "../props/spacing";
import pureProps from "../utils/pureProps";

export const AlertRow = ({
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	children,
	...props
}) => (
	<Paragraph
		sx={{ fontSize: "m", ...pureProps(sx) }}
		spacing={{ my: 0, ...pureProps(spacing) }}
		{...props}
	>
		{children}
	</Paragraph>
);

AlertRow.propTypes = {
	sx: sxPropTypes,
	spacing: spacingPropTypes,
	isLast: bool,
	...Paragraph.propTypes,
};

export const AlertLink = ({ href, children, ...props }) => (
	<Link href={href} className="alert__link" {...props}>
		{children}
	</Link>
);

AlertLink.propTypes = {
	...Link.propTypes,
};

const Alert = ({ title = "", status = "success", className = "", children }) => {
	return (
		<div className={classes("alert", `alert--${status}`, className)}>
			{title && (
				<Heading Tag="h3" className="alert__title">
					{title}
				</Heading>
			)}
			{children}
		</div>
	);
};
Alert.propTypes = {
	title: node,
	status: oneOf(["default", "success", "error", "warning"]),
	className: string,
	children: node.isRequired,
};

Alert.Row = AlertRow;

Alert.Link = AlertLink;

export default Alert;
